export const ewmAppRouteModuleResolver = (app) => {
    switch (app) {
        case 'accountdata':
            return () => import('accountdata/AccountDataModule');
        case 'monitoring':
            return () => import('monitoring/MonitoringModule');
        case 'insights':
            return () => import('insights/InsightsModule');
        case 'bic':
            return () => import('bic/BicModule');
        case 'bat':
            return () => import('bat/BatModule');
    }
    return () => import(`../pages/NotFoundPage`);
};
